import { useContext, useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import { API } from './api';
import { InfoContext } from '../context';

type PortalFeatures = {
	features: string[];
	arePortalFeaturesResolved: boolean;
};

/**
 * Fetches the enabled portal feature (ECA) ids for the current portal.
 *
 * Gate on a feature by membership, e.g. `features.includes(SOME_FEATURE_ID)`;
 * gate on the fetch having completed via `arePortalFeaturesResolved`.
 */
export const usePortalFeatures = (): PortalFeatures => {
	const { general } = useContext(InfoContext);
	const portalId = general.accountId;
	const [features, setFeatures] = useState<string[]>([]);
	const [arePortalFeaturesResolved, setArePortalFeaturesResolved] = useState(false);

	useEffect(() => {
		if (!portalId) {
			return;
		}

		const fetchPortalFeatures = async () => {
			try {
				setFeatures(await API.getPortalFeatures(portalId));
			} catch (error) {
				captureException(error);
			} finally {
				setArePortalFeaturesResolved(true);
			}
		};

		fetchPortalFeatures();
	}, [portalId]);

	return { features, arePortalFeaturesResolved };
};
